import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as bulkUploadActions from './actions';

export function* getUploadTypes() {
  const request = api.getUploadTypesRequest.bind(null);
  yield fetchEntity(request, bulkUploadActions.getUploadTypes);
}

export function* uploadBulkFile(payload) {
  const request = api.uploadBulkFileRequest.bind(null, payload);
  yield fetchEntity(request, bulkUploadActions.uploadBulkFile, payload);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetUploadTypesSaga() {
  while (true) {
    yield take(bulkUploadActions.GET_UPLOAD_TYPES[REQUEST]);
    yield fork(getUploadTypes);
  }
}

export function* watchUploadBulkFileSaga() {
  while (true) {
    const { payload } = yield take(bulkUploadActions.UPLOAD_BULK_FILE[REQUEST]);
    yield fork(uploadBulkFile, payload);
  }
}

